import type { ReactNode } from 'react';

type Props = {
  children: ReactNode;
};

/**
 * Shared presentational shell for short product info notices (age restriction,
 * not-for-sale, …): an info icon beside a message in a subtle bordered box.
 * Callers own their own visibility guard and pass the message as children.
 */
export default function InfoNotice({ children }: Props) {
  return (
    <div className="rounded-lg border border-ui-border-base bg-ui-bg-subtle p-3">
      <div className="flex gap-x-2">
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          className="text-ui-fg-subtle shrink-0 mt-0.5"
          aria-hidden="true"
        >
          <path
            d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
            stroke="currentColor"
            strokeWidth="2"
          />
          <path
            d="M12 8v4m0 4h.01"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <p className="text-sm text-ui-fg-subtle">{children}</p>
      </div>
    </div>
  );
}
